import { CustomerPermission } from 'src/pages/config/permission/permission';
import useAuth from './useAuth';

const useCustomerFeature = (key: string) => {
    const { user } = useAuth();
    const feature = user?.customerFeatures?.find(
        (f: CustomerPermission) => f.key.toUpperCase() === key.toUpperCase()
    );
    return {
        enabled: !!feature,
        areas: feature?.metadata?.areas ?? [],
        hasAreas: (feature?.metadata?.areas?.length ?? 0) > 0,
        defaultArea: feature?.metadata?.defaultArea,
        locHierCategoryId: feature?.metadata?.locHierCategoryId,
        metadata: feature?.metadata,
    };
};

export default useCustomerFeature;